import React, { useEffect } from 'react';
import classNames from 'classnames';
import { useConsentGroups } from '../../hooks/useConsentGroups';
import * as PropTypes from 'prop-types';

export function SupportChatLink({
  children,
  className,
  isChatLive = false,
  ...props
}) {
  const { isFunctionalGroupActive } = useConsentGroups();

  useEffect(() => {
    if (isFunctionalGroupActive) {
      window.Intercom('boot');
    } else {
      window.Intercom('shutdown');
    }
  }, [isFunctionalGroupActive]);

  if (!isFunctionalGroupActive) {
    return null;
  }

  function OpenIntercom(ev) {
    window.Intercom('show');
    ev.preventDefault();
    return;
  }

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <>
      <a
        href="#intercom"
        title="Open Chat"
        target="_self"
        aria-label="Need Help? Open Chat."
        onClick={(ev) => OpenIntercom(ev)}
        className={classNames(
          { 'no-underline text-yellow-live hover:text-white transition-colors': isChatLive },
          className
        )}
        {...props}
      >
        {children}
      </a>
    </>
  );
}

SupportChatLink.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  isChatLive: PropTypes.bool,
};

export default SupportChatLink;


